module.exports = __webpack_public_path__ + "img/jkopay.b6e92028.png";